import { Component, Vue, Prop } from 'vue-property-decorator';
import { useEquestHome } from '@/config/app.config';
import { GetterTypes } from '@/store-vuex/types';
import moment from 'moment';
import { McsisConstants } from '@/models/constants/McsisConstants';
import { ParticipantDTO } from '@/models/ParticipantDTO';
import { AppointmentDTO } from '@/models/AppointmentDTO';
import EavService from '@/services/eav.services';
import { EavAttributeName, EavClassName, EavParent } from '@/models/constants/eav';

@Component
export default class TemplateDefault extends Vue {
  @Prop({ default: '' })
  public confirmationTitle!: string;
  @Prop({ default: '' })
  public confirmationMessage!: string;

  private isEQuestUsedByCenter = false;
  
  protected async mounted(): Promise<void> {
    if (this.appointment.center != null && this.appointment.center.personId != null)
    {
      await EavService.getBooleanEav(
        EavParent.EXAM_CENTER, 
        this.appointment.center.personId, 
        EavClassName.EXAM_CENTER_PARAM, 
        EavAttributeName.USE_EQUESTIONNAIRE
      ).then((res: boolean) => {
        this.isEQuestUsedByCenter = res;
      });
    }
  }

  private get participant(): ParticipantDTO {
    return this.$store.getters[GetterTypes.participant];
  }

  private get appointment(): AppointmentDTO {
    return this.$store.getters[GetterTypes.appointment];
  }

  /**
   * Gets true if AppointmentParticipant step must be displayed
   *
   * @returns {boolean} true or false
   */
  public get showAppointmentParticipantStep(): boolean {
      return this.$store.getters[GetterTypes.showAppointmentParticipantStep];
  }

  /**
   * Check whether we have to display or not the E-Quest@Home link button
   */
  protected get showEquestLink(): boolean {
    return useEquestHome(this.$route.params.screening)
      && !this.isModified
      && !this.showAppointmentParticipantStep
      && (this.isEQuestUsedByCenter);
  }

  private get isModified(): boolean {
    return this.$store.getters[GetterTypes.isRdvModified];
  }

  private get equestRouteName(): string {
    const equest = process.env.VUE_APP_EQUEST_ROOT;
    const suName = this.$route.params.screening;
    const birthDate = moment(this.participant.birthDate!).format(McsisConstants.SwissDateFormat);
    const partId = this.participant.partId;

    return `${equest}/${suName}/at-home/identification?partId=${partId}&birthDate=${birthDate}`;
  }
}
